import { render, staticRenderFns } from "./UserFormComponent.vue?vue&type=template&id=d83a971e&"
import script from "./UserFormComponent.vue?vue&type=script&lang=js&"
export * from "./UserFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./UserFormComponent.vue?vue&type=style&index=0&id=d83a971e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports